import $ from 'jquery';

function init() {
  $("#saddr").keyup(function(){
    if($('#saddr').val().length >= 3) {
      $('button[type="submit"].btn').prop("disabled", false);
    } else {
      $('button[type="submit"].btn').prop("disabled", true);
    }
  });
}

// -------------------------------------------------------------------------------------------------
// Export
// -------------------------------------------------------------------------------------------------

export default {
  init,
};
